export default __webpack_public_path__ + "static/media/closet5-before2-1024w.5ef56063.webp";